<template>
  <div class="text-standard">
    <div class="h-fiftyvh md:h-screen antea bg-cover bg-center relative" />
    <div class="container mx-auto flex flex-row flex-wrap">
      <div class="w-full flex mt-8 laptop:mt-32">
        <div class="laptop:w-6/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-full">
          <h1 class="text-antea font-normal">an<span class="font-bold">tea</span> stress</h1>
        </div>
      </div>
      <div class="w-full flex flex-wrap md:mx-3 laptop:mx-0 mt-4">
        <div class="laptop:w-6/12 px-5 lg:pr-8 laptop:px-24 lg:w-1/2 w-full">
          <p>In the office environment, one of the constants is stress, often caused by hypertension, in most cases it is neglected or considered an irrelevant problem.</p>
        </div>
        <div class="laptop:w-6/12 px-5 lg:pl-8 laptop:px-24 lg:w-1/2 w-full">
          <p>The idea of AN<span class="font-bold">TEA</span> STRESS was born to help defeat office stress, with customised herbal teas that are based on the blood pressure measured.</p>
        </div>
      </div>
    </div>
    <div class="container mx-auto min-660 md:min-800 mt-12 laptop:my-100px">
      <iframe
        allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true"
        class="min-660 md:min-800"
        style="width:100%; height:100%;"
        :src="'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/cce8151b-6dc1-5542-a398-8772a44ff45e/default/ebd184e3-da84-5353-afab-fef6eed3d544/index.html?language=' + $i18n.locale"
      />
    </div>
    <div class="container mx-auto my-16 laptop:my-150px">
      <div class="grid grid-cols-1 laptop:grid-cols-2 gap-8 gap-y-12 laptop:gap-16 laptop:gap-y-32 px-5 laptop:px-24 ">
        <div class="flex flex-col">
          <div class="mb-8">
            <img loading="lazy" src="~/assets/img/examples/ico-antea-1.svg">
          </div>
          <p>In Europe, the office coffee market is around 3.1 billion Euros. Italy, France, Germany, Spain and the UK represent the 72% of the total value, with an average growth of 3.3% over the last three years.</p>
        </div>
        <div class="flex flex-col">
          <div class="mb-8">
            <img loading="lazy" src="~/assets/img/examples/ico-antea-2.svg">
          </div>
          <p>For the coffee break, for practicality and tight deadlines, we are all tied to vending machines that dispense hot and soft drinks. Only 3 out of 10 Italians drink tea and herbal teas prepared by themselves during the classic working day.</p>
        </div>
        <div class="flex flex-col">
          <div class="mb-8">
            <img loading="lazy" src="~/assets/img/examples/ico-antea-3.svg">
          </div>
          <p>From 20 to 60 years old, about 1 in 10 people drink 2 glasses of sodas a day, while 7 out of 10 people drink at least 1.5 coffee in the office. We believe it is important to provide a healthy alternative. (source: www.istat.it)</p>
        </div>
        <div class="flex flex-col">
          <div class="mb-8">
            <img loading="lazy" src="~/assets/img/examples/ico-antea-4.svg">
          </div>
          <p>
            The excess of adrenaline generated by the consumption of caffeine and sugars does not only affect behaviours. Large doses of the latter increase the pressure, resulting in the release of cortisol: the hormone responsible for stress.
            (source: Carnegie Mellon University, Pittsburgh Pennsylvania)
          </p>
        </div>
      </div>
    </div>
    <div class="w-full">
      <img loading="lazy" class="w-full" src="~/assets/img/examples/antea-big-1.webp">
    </div>
    <div class="container mx-auto flex flex-col md:flex-row my-16 laptop:my-150px">
      <div class="laptop:w-6/12 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0 laptop:pl-12">
        <p class="xl:ml-12 text-standard text-base md:text-base mb-8">
          <b>Technical specifications:</b><br>
          Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
        </p>
        <p class="xl:ml-12 text-standard text-base md:text-base mb-8 xl:mb-24">
          <b>Maintenance:</b><br>
          Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
        </p>
        <div class="divide-y divide-braungray xl:ml-12">
          <div class="flex py-4 justify-between">
            <div class="w-1/2">
              <b>Model</b>
            </div>
            <div class="w-1/2">
              <p>exercise</p>
            </div>
          </div>
          <div class="flex py-4 justify-between">
            <div class="w-1/2">
              <b>Designer</b>
            </div>
            <div class="w-1/2">
              <p>Politecnico Milano</p>
            </div>
          </div>
          <div class="flex py-4 justify-between">
            <div class="w-1/2">
              <b>Colour</b>
            </div>
            <div class="w-1/2">
              <p>Verde o grigio</p>
            </div>
          </div>
          <div class="flex py-4 justify-between">
            <div class="w-1/2">
              <b>Material</b>
            </div>
            <div class="w-1/2">
              <p>Plastic, metal, glass</p>
            </div>
          </div>
          <div class="flex py-4 justify-between">
            <div class="w-1/2">
              <b>Product weight</b>
            </div>
            <div class="w-1/2">
              <p>00 kg</p>
            </div>
          </div>
          <div class="flex py-4 justify-between">
            <div class="w-1/2">
              <b>Product size</b>
            </div>
            <div class="w-1/2">
              <p>00 (L) x 00 (W) x 00 (H) inches</p>
            </div>
          </div>
        </div>
      </div>
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2">
        <div class="w-full mt-24">
          <img loading="lazy" class="mx-auto" src="~/assets/img/examples/antea-scheme.webp">
        </div>
      </div>
    </div>

    <div class="container mx-auto">
      <img loading="lazy" class="hidden lg:block" src="~/assets/img/examples/antea-schema-all.webp">
      <img loading="lazy" class="block lg:hidden w-full" src="~/assets/img/examples/antea-schema-half-1.webp">
      <img loading="lazy" class="block lg:hidden w-full" src="~/assets/img/examples/antea-schema-half-2.webp">
      <img loading="lazy" class="block lg:hidden w-full" src="~/assets/img/examples/antea-schema-half-3.webp">
    </div>

    <TryIt />
    <div class="hidden md:block">
      <img loading="lazy" class="mx-auto" src="~/assets/img/examples/antea-schema.webp">
    </div>
  </div>
</template>

<script lang="ts">
import TryIt from '@/components/TryIt.vue'
export default defineNuxtComponent({
  components: { TryIt },
})
</script>

<style scoped>
.antea {
  background-image: url("~/assets/img/examples/antea-hero.webp");
}
</style>
